import React, { useCallback, useContext, useEffect, useState } from 'react';
import { EditContext } from '../context/EditContext';
import {
  HeroForm, HomeFeaturesForm, HomeClosingForm, ContactForm, SocialsForm,
  FooterForm, ServicesProcessForm, AboutForm, ServicesForm, TestimonialsForm,
  PortfolioCategoryForm,
} from './edit/forms';

function pickForm(descriptor, props) {
  if (!descriptor) return null;
  const { kind, key } = descriptor;
  if (kind === 'services') return <ServicesForm {...props} />;
  if (kind === 'testimonials') return <TestimonialsForm {...props} />;
  if (kind === 'portfolio_category') return <PortfolioCategoryForm categoryKey={key} {...props} />;
  if (kind === 'config') {
    switch (key) {
      case 'hero': return <HeroForm {...props} />;
      case 'home_features': return <HomeFeaturesForm {...props} />;
      case 'home_closing': return <HomeClosingForm {...props} />;
      case 'about': return <AboutForm {...props} />;
      case 'contact': return <ContactForm {...props} />;
      case 'socials': return <SocialsForm {...props} />;
      case 'footer': return <FooterForm {...props} />;
      case 'services_process': return <ServicesProcessForm {...props} />;
      default: return null;
    }
  }
  return null;
}

export default function EditDrawer() {
  const { editing, closeEditor, bumpConfig } = useContext(EditContext);
  const [status, setStatus] = useState('');
  const [toast, setToast] = useState('');

  const isOpen = !!editing;

  const handleClose = useCallback(() => { closeEditor(); setStatus(''); }, [closeEditor]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') handleClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, handleClose]);

  const onSaved = useCallback(() => {
    bumpConfig();
    setToast('Saved.');
    setTimeout(() => setToast(''), 1500);
    setTimeout(() => { closeEditor(); setStatus(''); }, 250);
  }, [bumpConfig, closeEditor]);

  return (
    <>
      {isOpen && <div className="edit-drawer-backdrop" onClick={handleClose} />}
      <aside className={`edit-drawer ${isOpen ? 'is-open' : ''}`} aria-hidden={!isOpen}>
        {editing && (
          <>
            <header className="edit-drawer-head">
              <h2>{editing.label || 'Edit'}</h2>
              <button type="button" className="edit-drawer-close" onClick={handleClose} aria-label="Close">×</button>
            </header>
            {status && <div className="admin-status">{status}</div>}
            <div className="edit-drawer-body">
              {pickForm(editing, { onSaved, setStatus })}
            </div>
            {toast && <div className="edit-drawer-toast">{toast}</div>}
          </>
        )}
      </aside>
    </>
  );
}
